import React, { Component } from 'react'
import '../../style/movie-details.less'
import LoaderIcon from '../../icons/loading.svg'
import EmptyPoster from '../../icons/poster-empty-state.svg'

class MovieDetails extends React.Component {

  constructor(props) {
      super(props)
      this.state = {
          showMore: false,
      }
  }

  showMore = () => {
    this.setState({showMore: !this.state.showMore})
  }

  render () {
    let {
      loading,
      error,
      imageUrl,
      name,
      year,
      language,
      genres,
      synopsis,
    } = this.props

    let {
      showMore
    } = this.state

    let synopsisText = synopsis

    if(synopsis && synopsis.length > 160){
       synopsisText = synopsis.substring(0, 160)
     }

    if(showMore){
       synopsisText = synopsis
     }


    if(loading){
      return(
        <div className="movie-modal-loading-view">
         <LoaderIcon className="qw-icon-x-large"/>
        </div>
      )
    }
    else if(error){
      return(
        <div className="movie-modal-loading-view">
         <div>
           <p style={{textAlign: 'center'}}>oops!</p>
           <p>Sorry something went wrong</p>
         </div>
        </div>
      )
    }
    else {
        return(
          <div className="movie-details-modal-overview">
           <div className="movie-poster-view">
            <div className="movie-poster-image">
              {
                imageUrl ?
                <img src={imageUrl} alt={name} />
                :
                <EmptyPoster />
              }
            </div>
           </div>
           <div className="movie-details-view">
             <div className="movie-details-name">
               <p>Movie Name</p>
               <p>{name}
                {
                  year &&
                  <span>&nbsp;({year})</span>
                }
               </p>
             </div>
             <div className="movie-details-language">
               <div>
                <p>Language</p>
                <p>{language ? language : 'NA'}</p>
               </div>
             </div>
             <div className="movie-details-genre">
               <p>Genres</p>
               <p>{genres ? genres : 'NA'}</p>
             </div>
             <div className="movie-details-synopsis">
                <p className="heading-synopsis">Synopsis</p>
                <div className="movie-synopsis-view">
                 {
                   synopsisText ?
                   <p>
                    {synopsisText}
                    {
                      (synopsis && synopsis.length > 160) &&
                      <span onClick={() => this.showMore()} style={{marginLeft: 5, color:'#108EE9', cursor:'pointer'}}>{showMore ? 'Show less' : 'Show more'}</span>
                    }
                   </p>
                   :
                   <p>NA</p>
                 }
                </div>
             </div>
           </div>
          </div>
        )
      }

  }
}

export default MovieDetails



// WEBPACK FOOTER //
// ./src/app/components/compositions/MovieDetails.js